import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { IdsForSettingsService } from '../ids-for-settings.service';

@Component({
  selector: 'settings-navigation',
  templateUrl: './settings-navigation.component.html'
})
export class SettingsNavigationComponent implements OnInit, OnDestroy {

  selectedUserId: string = '';
  selectedOrganisationId: string = '';
  selectedWhiteLabelId: string = '';

  private myUser!: User;

  public get myUserName(): string {
    return this.myUser?.fullName ?? "";
  }
  public get allowedToAccessAnySettings(): boolean {
    return this.myUser && (this.myUser.isOrganisationAdmin || this.myUser.isWhitelabelAdmin || this.myUser.isSystemAdmin)
  }
  public get allowedToAccessWhitelabel(): boolean {
    return this.myUser && (this.myUser.isWhitelabelAdmin || this.myUser.isSystemAdmin)
  }
  public get allowedToAccessSystem(): boolean {
    return this.myUser && (this.myUser.isSystemAdmin)
  }

  // COLOURS FOR ORGANISATION
  storageOrganisationAvailable: boolean = false;
  brandingOrganisationAvailable: boolean = false;
  // COLOURS FOR WHITELABEL
  storageWhiteLabelAvailable: boolean = false;
  brandingWhiteLabelAvailable: boolean = false;

  userSubscription: Subscription = new Subscription();
  organisationSubscription: Subscription = new Subscription();
  whiteLabelSubscription: Subscription = new Subscription();

  constructor(private authenticationService: AuthenticationService,
    private identityOrganisationApiClient: IdentityOrganisationApiClient,
    private identityWhitelabelApiClient: IdentityWhitelabelApiClient,
    public idsForSettingsService: IdsForSettingsService) {
  }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe(user => {
      this.myUser = user;
    });

    this.organisationSubscription = this.idsForSettingsService.selectedOrganisation$.subscribe(organisation => {
      if (!organisation.organisationGuid) {
        // this menu sometimes is earlier than the setup of service, so catch the initial empty
        return;
      }
      this.selectedOrganisationId = organisation.organisationGuid;
      this.identityOrganisationApiClient.getOrganisation(organisation.organisationGuid).subscribe(organisationData => {
        this.brandingOrganisationAvailable = organisationData.organisation.whitelabelEnabled;
        this.storageOrganisationAvailable = organisationData.organisation.customStorageEnabled;
      });
    });

    this.userSubscription = this.idsForSettingsService.selectedUser$.subscribe(user => {
      this.selectedUserId = user.userGuid;
    });

    this.whiteLabelSubscription = this.idsForSettingsService.selectedWhiteLabel$.subscribe(whiteLabel => {
      if (!whiteLabel.whiteLabelGuid) {
        // this menu sometimes is earlier than the setup of service, so catch the initial empty
        return;
      }
      this.selectedWhiteLabelId = whiteLabel.whiteLabelGuid;
      this.identityWhitelabelApiClient.getWhitelabel(this.selectedWhiteLabelId).subscribe(whiteLabelData => {
        this.brandingWhiteLabelAvailable = whiteLabelData.whiteLabel.whitelabelEnabled;
        this.storageWhiteLabelAvailable = whiteLabelData.whiteLabel.customStorageEnabled;
      });
    });
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.organisationSubscription.unsubscribe();
    this.whiteLabelSubscription.unsubscribe();
  }
}
